import ReactDOM from 'react-dom';

import App from './App';

import { Auth } from "aws-amplify";

import ConfigAws from "./config/config";

import './index.scss';
import './bootstrap.min.css';

Auth.configure(ConfigAws);

ReactDOM.render(<App />, document.getElementById('root'));
